export default __webpack_public_path__ + "static/media/logo-black.f370ad13.svg";